import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Card, Btn, Badge, AInput, ATextarea, ASelect, EmptyState } from "../AdminUI";
import { Plus, Trash2, HelpCircle } from "lucide-react";

export default function FaqsAdmin() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/admin/faqs").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const blank = { question: "", answer: "", status: "published" };

  const saveF = async () => {
    try {
      if (edit.id) await api.patch(`/admin/faqs/${edit.id}`, edit);
      else await api.post("/admin/faqs", edit);
      toast.success("Saved"); setEdit(null); load();
    } catch { toast.error("Failed"); }
  };
  const del = async (id) => { if (!window.confirm("Delete FAQ?")) return; await api.delete(`/admin/faqs/${id}`); load(); };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="font-head font-extrabold text-3xl text-[var(--navy)] uppercase tracking-tight">FAQs</h1>
        <Btn onClick={() => setEdit(blank)} data-testid="add-faq"><Plus className="w-4 h-4" /> Add FAQ</Btn>
      </div>

      {edit && (
        <Card title={edit.id ? "Edit FAQ" : "New FAQ"}>
          <div className="space-y-3">
            <AInput label="Question" value={edit.question} onChange={(e) => setEdit({ ...edit, question: e.target.value })} />
            <ATextarea label="Answer" value={edit.answer} onChange={(e) => setEdit({ ...edit, answer: e.target.value })} />
            <ASelect label="Status" value={edit.status} options={["published", "draft"]} onChange={(e) => setEdit({ ...edit, status: e.target.value })} />
          </div>
          <div className="flex gap-2 mt-4"><Btn onClick={saveF}>Save</Btn><Btn variant="ghost" onClick={() => setEdit(null)}>Cancel</Btn></div>
        </Card>
      )}

      {items.length === 0 ? <Card><EmptyState icon={HelpCircle} title="No FAQs yet" /></Card> : (
        <Card>
          <div className="divide-y divide-gray-100">
            {items.map((f) => (
              <div key={f.id} className="py-3">
                <div className="flex items-start justify-between gap-3">
                  <div><p className="font-semibold text-[var(--navy)]">{f.question} <Badge color={f.status === "published" ? "green" : "amber"}>{f.status}</Badge></p>
                    <p className="text-sm text-gray-500 mt-1">{f.answer}</p></div>
                  <div className="flex gap-2 shrink-0"><Btn variant="ghost" onClick={() => setEdit(f)}>Edit</Btn><Btn variant="danger" onClick={() => del(f.id)}><Trash2 className="w-4 h-4" /></Btn></div>
                </div>
              </div>
            ))}
          </div>
        </Card>
      )}
    </div>
  );
}
